import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {rdvActivationApiService} from "./rdvActivationApi.service.js";

export const rdvActivationKeysStore = {
  root: ["rdvActivation"] as const,
  status: () => [...rdvActivationKeysStore.root, "status"] as const,
};

export function useRdvActivationStatus() {
  const {data, isLoading, isFetching, refetch} = useQuery({
    queryKey: rdvActivationKeysStore.status(),
    queryFn: rdvActivationApiService.getRdvActivationStatus,
    refetchOnWindowFocus: false,
    // Volatile: the config it derives from (address, services, team) changes in
    // adjacent screens, so keep it short so the switch reflects reality quickly.
    staleTime: 2 * 60 * 1000,
  });

  return {
    rdvActivationStatus: data,
    isRdvActivationStatusLoading: isLoading,
    isRdvActivationStatusFetching: isFetching,
    refetchRdvActivationStatus: refetch,
  };
}

export function useUpdateRdvActivation() {
  const queryClient = useQueryClient();
  const {mutateAsync, isPending} = useMutation({
    mutationFn: rdvActivationApiService.updateRdvActivation,
    onSuccess(status) {
      queryClient.setQueryData(rdvActivationKeysStore.status(), status);
    },
    onError(error) {
      console.error("Failed to update RDV activation:", error);
    },
  });
  return {updateRdvActivation: mutateAsync, isUpdatingRdvActivation: isPending};
}
